<div class="content-wrapper" [class.edit-mode]="editMode">
    <ng-container *ngIf="!isUnset; else unsetChart">
        <pv-generic-report-graph
            [graphControl]="chartControl"
            [compiledData]="getChartValue()"
            [typography]="typography"
        >
        </pv-generic-report-graph>
    </ng-container>
    <ng-template #unsetChart>
        <div *ngIf="editMode" class="component-placeholder">
            <mat-icon class="material-symbols-outlined placeholder-icon">bar_chart</mat-icon>
            <span class="placeholder-title">Measure Chart</span>
            <span class="placeholder-hint">Open the menu to select a measure and chart type</span>
        </div>
    </ng-template>

    <div *ngIf="editMode" class="content-options no-print">
        <button
            mat-icon-button
            matTooltip="Item Actions"
            [matMenuTriggerFor]="optionMenu"
        >
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>
</div>

<mat-menu #optionMenu>
    <ng-template matMenuContent>
        <button mat-menu-item (click)="edit()">
            <mat-icon>edit</mat-icon>
            <span>Edit Item </span>
        </button>

        <button mat-menu-item (click)="remove()">
            <mat-icon>delete</mat-icon>
            <span>Delete Item</span>
        </button>

        <!-- Duplicate temporarily hidden
        <button mat-menu-item (click)="makeDuplicate()">
            <mat-icon>content_copy</mat-icon>
            <span>Duplicate</span>
        </button>
        -->

        <button mat-menu-item (click)="editTypography.emit()">
            <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
            <span>Font</span>
        </button>

       <button mat-menu-item [matMenuTriggerFor]="layering">
            <mat-icon class="material-symbols-outlined">
                stack
            </mat-icon>
            <span>Layering ({{ layerIndex }})</span>
        </button>
    </ng-template>
</mat-menu>

<mat-menu #layering="matMenu">
    <button mat-menu-item (click)="moveToTop()">
        <mat-icon class="material-symbols-outlined">
            arrow_shape_up_stack
        </mat-icon>
        <span>Send to Top</span>
    </button>
    <button mat-menu-item (click)="moveForward()">
        <mat-icon class="material-symbols-outlined">
            arrow_shape_up
        </mat-icon>
        <span>Move Forward</span>
    </button>
    <button mat-menu-item (click)="moveDown()">
        <mat-icon class="material-symbols-outlined flipped-icon">
            arrow_shape_up
        </mat-icon>
        <span>Move Down</span>
    </button>
    <button mat-menu-item (click)="moveToBottom()">
        <mat-icon class="material-symbols-outlined flipped-icon">
            arrow_shape_up_stack
        </mat-icon>
        <span>Send to Back</span>
    </button>
</mat-menu>
